import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { converter } from '../../../../helpers/converter';
import { dateParse } from './SectionPurchaseUtil';
import DateButton from './DateButton';

export default class PlayButton extends Component {
  static propTypes = {
    purchaseInfo: PropTypes.object,
    translations: PropTypes.object,
    params: PropTypes.object,
    onPlay: PropTypes.func,
    callMetrics: PropTypes.func,
  };

  handleClick = () => {
    const { onPlay, params, callMetrics } = this.props;
    let eventAction;
    eventAction = 'Ver';
    callMetrics(eventAction);
    onPlay({ props: params });
  };

  render() {
    const { purchaseInfo, translations } = this.props;

    const button = purchaseInfo.playButton;
    const startDate = button.startdate;

    if (startDate) {
      if (dateParse(startDate) > Date.now()) {
        return <DateButton {...this.props} />;
      }
    }

    if (purchaseInfo.playButton.visible === '1') {
      return (
        <button
          className="btn btn-default btn-lg primary"
          onClick={this.handleClick}
        >
          <span className="text-inline">
            {converter
              .convertApaUnicode(translations, 'detail_play', 'Ver')
              .toLowerCase()}
          </span>

          <i className="fa fa-play icon-inline" />
        </button>
      );
    }
    return null;
  }
}
